import React__default from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PlusIcon = (props) => /* @__PURE__ */ React__default.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React__default.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement(
  "path",
  {
    d: "M12.5 6v5.5H18v1h-5.5V18h-1v-5.5H6v-1h5.5V6h1z",
    transform: "translate(-129 -269) translate(97 105) translate(23 155) rotate(-90 21 12)"
  }
))))));

export { PlusIcon as default };
//# sourceMappingURL=PlusIcon.js.map
